import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Panel, PageTitle } from "@/components/ui/Panel";
import { Input, Label } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";
import { toast } from "sonner";

export function SignIn() {
  const { signIn, signUp, user } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState<"signin" | "signup">("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) {
    return (
      <Panel>
        <p className="text-sm">You are signed in. <button className="gm-link" onClick={() => navigate("/")}>Return home</button></p>
      </Panel>
    );
  }

  async function handle(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      const err = mode === "signin"
        ? await signIn(email, password)
        : await signUp(email, password, displayName || email.split("@")[0]);
      if (err) toast.error(err);
      else {
        toast.success(mode === "signin" ? "Signed in" : "Account created — check your email");
        if (mode === "signin") navigate("/");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-md space-y-4">
      <PageTitle>{mode === "signin" ? "Sign in" : "Create account"}</PageTitle>
      <Panel>
        <form className="space-y-3" onSubmit={handle}>
          {mode === "signup" && (
            <div>
              <Label htmlFor="display_name">Display name</Label>
              <Input id="display_name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
            </div>
          )}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button type="submit" disabled={busy} className="w-full">
            {busy ? "Working…" : mode === "signin" ? "Sign in" : "Create account"}
          </Button>
        </form>
        <button
          className="mt-3 w-full text-xs text-[#64748b] hover:text-amber-soft"
          onClick={() => setMode((m) => (m === "signin" ? "signup" : "signin"))}
        >
          {mode === "signin" ? "Need an account? Sign up" : "Already have an account? Sign in"}
        </button>
      </Panel>
    </div>
  );
}
